<template>
  <el-dialog
      v-dialogDrag
      title="新增用户"
      :visible="visible"
      width="60%"
      @open="open"
      @close="close"
      :close-on-click-modal="false"
  >
    <el-form
        v-loading="loading"
        element-loading-text="请稍候..."
        label-width="100px"
        class="operation"
        :model="form"
        ref="form"
    >
      <el-row>
        <el-col :xs="8" :sm="12">
          <el-form-item label="部门">
            {{form.departmentName}}
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="12">
          <el-form-item label="用户名" prop="account">
            <el-input
                type="text"
                size="medium"
                v-model="form.account"
                placeholder="请输入用户名"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="姓名" prop="name">
            <el-input
                type="text"
                size="medium"
                v-model="form.name"
                placeholder="请输入姓名"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="电话" prop="mobile">
            <el-input
                type="text"
                size="medium"
                v-model="form.mobile"
                placeholder="请输入电话"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="邮箱" prop="email">
            <el-input
                type="text"
                size="medium"
                v-model="form.email"
                placeholder="请输入邮箱"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="备注" prop="remark">
            <el-input
                type="text"
                size="medium"
                v-model="form.remark"
                placeholder="请输入备注"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="22" class="text-right">
          <el-button size="medium" @click="close" type="default"
          >取消
          </el-button
          >
          <el-button size="medium" @click="submitForm('form')" type="primary"
          >保存
          </el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import dialog from "@/components/mixins/dialog";
import {addUser} from "./api/index";

export default {
  mixins: [dialog],
  props: {
    form: {
      type: Object,
      default: {
        account: "",
        name: "",
        remark: "",
        mobile: "",
        email: "",
        roleIds: [],
        groupIds: [],
        departmentId: null,
        departmentName: ''
      }
    },
  },
  data() {
    return {

    };
  },
  methods: {
    submitForm(formName) {
      let data = Object.assign({}, this.form);
      data.chName = this.form.chName;
      data.url = this.form.url;
      data.type = this.form.type;
      data.enabled = this.form.enabled;
      data.parentId = this.form.parentId;
      data.remark = this.form.remark;
      data.orgId = this.form.departmentId
      addUser(data)
          .then((res) => {
            if (res.data.code == 20000) {
              this.$emit("success");
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            });
          });
    },
    open(name = "form") {
      //打开对话框先清除上次残留数据
      if (this.$refs[name]) {
        this.$refs[name].resetFields();
        // this.$refs.editor.initValue("");
      }
    },
  },
};
</script>
<style scoped>
.text-right {
  text-align: right;
}
</style>


